module.exports = __webpack_public_path__ + "img/crude_oil.736be2b.jpg";